import { Box, CircularProgress, Flex } from "@chakra-ui/react";

// TODO: remove when we have DS for loading
const LoadingProgress = () => {
  return (
    <Flex
      w="100%"
      h="100%"
      position="absolute"
      zIndex={1000}
      left={0}
      justifyContent="center"
      alignItems="center"
    >
      <Box
        position="absolute"
        backgroundColor="#ffffff"
        opacity={0.6}
        zIndex={1}
        width="100%"
        height="100%"
      />
      <CircularProgress
        isIndeterminate
        color="primary.500"
        position="absolute"
        zIndex={2}
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
      />
    </Flex>
  );
};

export default LoadingProgress;
